import styled from "styled-components";
const LoaderDisplay = styled.div`
	// my css here
`;	export default LoaderDisplay;
